import { useAtomValue } from "jotai";
import { useCallback } from "react";
import { Button } from "@zapier/design-system";
import { Icon } from "@zapier/zinnia-icons";
import { AssetType, assetTypeAndLinkAtomFamily } from "@zapier/canvas-state";

import { useOpenAsset } from "../../hooks/useOpenAsset";

type Props = {
  nodeId: string;
};

function isValidEventAssetType(
  val: any,
): val is Exclude<AssetType, undefined | "zap"> {
  return ["zap", "table", "interface", "chatbot"].includes(val);
}

export function EditAssetButton({ nodeId }: Props) {
  const { assetType, assetLink } = useAtomValue(
    assetTypeAndLinkAtomFamily(nodeId),
  );
  const openAsset = useOpenAsset();

  const onPress = useCallback(() => {
    if (assetType && isValidEventAssetType(assetType)) {
      openAsset({ url: assetLink, assetType, location: "tour" });
    }
  }, [openAsset, assetLink, assetType]);

  if (!assetType || !assetLink) {
    return null;
  }

  return (
    <Button
      variant="secondary"
      size="compact"
      iconPosition="end"
      onPress={onPress}
    >
      {`Edit ${assetType === "zap" ? "Zap" : assetType}`}
      <Icon name="arrowOffsite" />
    </Button>
  );
}
